import { useTranslation } from "react-i18next";
import { TranslationTextProps } from "./types";

/**
 * Uses react-i18next to get the text value defined in the i18 file
 * for the given keys in the current set language.
 */
const TranslationText = ({ jsonKeysPath, styles }: TranslationTextProps) => {
  const { t } = useTranslation();

  const transTextValue = t(jsonKeysPath, {
    defaultValue: "Value not found in translation files",
  });

  return <span className={styles}>{transTextValue}</span>;
};

export default TranslationText;
